// extracted by mini-css-extract-plugin
export var animationContainer = "_hq-0";
export var asteriskIcon = "_hq-8";
export var conversationLeftSection = "_hq-4";
export var conversationListItem = "_hq-3";
export var conversationMiddleSection = "_hq-5";
export var conversationRightSection = "_hq-6";
export var detailsContent = "_hq-1";
export var listContainer = "_hq-7";
export var modalContent = "_hq-2";